module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-index"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('el-carousel', {
    attrs: {
      "interval": 3000,
      "arrow": "always",
      "indicator-position": "none"
    }
  }, _vm._l((_vm.bannerCon), function(item, index) {
    return _c('el-carousel-item', {
      key: item.id
    }, [_c('div', {
      staticClass: "index-banner",
      style: ({
        'backgroundImage': 'url(' + _vm.$global.globalPath + item.src + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.goBannerLink(item.link, item.i_button)
        }
      }
    }, [_c('div', {
      staticClass: "w1200"
    }, [_c('div', {
      staticClass: "banner-contents",
      style: ({
        'text-align': item.position
      })
    }, [_c('div', {
      staticClass: "misc"
    }, [_c('h1', {
      staticClass: "banner-title f48"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.smalltitle) ? _c('h2', {
      staticClass: "banner-subtitle f36"
    }, [_vm._v(_vm._s(item.smalltitle.replace(/@/g, ' ')))]) : _vm._e(), _vm._v(" "), (item.smalltitle) ? _c('div', {
      staticClass: "banner-divider dib"
    }) : _vm._e(), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "main-misc",
      domProps: {
        "innerHTML": _vm._s(item.content.replace(/@/g, '<br/>'))
      }
    })])]), _vm._v(" "), (item.i_button === '1') ? _c('div', {
      staticClass: "banner-buttom"
    }, [(item.videoButtonShow) ? _c('el-button', {
      class: ("banner-button " + (item.position==='center'?'banner-button-center':'')),
      on: {
        "click": function($event) {
          return _vm.bannerClick('shouye-banner-tiyan')
        }
      }
    }, [_vm._v("申请体验\n                ")]) : _vm._e(), _vm._v(" "), (item.link && !item.videoButtonShow) ? _c('el-button', {
      class: ("banner-button " + (item.position==='center'?'banner-button-center':'')),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.gotoLink(item.link)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.title && item.position === 'center' ? item.title : '了解详情') + "\n                ")]) : _vm._e(), _vm._v(" "), (item.videoButtonShow) ? _c('el-button', {
      class: ("banner-button video-button " + (item.position==='center'?'banner-button-center':'')),
      on: {
        "click": function($event) {
          return _vm.openVideoPlayer(_vm.videoCon)
        }
      }
    }, [_vm._v("\n                  视频介绍\n                ")]) : _vm._e()], 1) : _vm._e()])])])])
  }), 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "srm-describe"
  }, [_c('div', {
    staticClass: "tc w1200"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.indexTitle[0].name || 'undefined'))]), _vm._v(" "), _c('p', {
    staticClass: "content-word",
    domProps: {
      "innerHTML": _vm._s(_vm.describeContent.replace('@', '</br>'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.srmList), function(item) {
    return _c('div', {
      key: item.code,
      staticClass: "content-item"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": item.title
      }
    }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [_c('a', {
      attrs: {
        "href": item.hrefUrl,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "go-detail"
    }, [_vm._v("了解详情 >")])]), _vm._v(" "), _c('el-button', {
      staticClass: "banner-button",
      on: {
        "click": function($event) {
          return _vm.bannerClick(item.code)
        }
      }
    }, [_vm._v("申请体验")])], 1)])
  }), 0)])]), _vm._v(" "), (_vm.purchaseCon[0] !== undefined) ? _c('div', {
    staticClass: "srm-purchase"
  }, [_c('div', {
    staticClass: "w1200 purchase-box"
  }, [_c('div', {
    staticClass: "srm-purchase-top"
  }, [_c('h1', [_vm._v(_vm._s(_vm.indexTitle[1].name || 'undefined'))]), _vm._v(" "), _c('p', [_vm._v("从真实应用场景出发，解决企业采购管理应用痛点")])]), _vm._v(" "), _c('div', {
    staticClass: "srm-purchase-tab w1200"
  }, [_c('el-tabs', {
    attrs: {
      "before-leave": _vm.preventSwitch
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_vm._l((_vm.purchaseTabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "name": item.name
      }
    }, [_c('div', {
      attrs: {
        "slot": "label"
      },
      on: {
        "mouseenter": function($event) {
          _vm.activeName = item.name
        }
      },
      slot: "label"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "srm-purchase-content"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": item.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('h2', [_vm._v(_vm._s(item.contentTitle))]), _vm._v(" "), _c('ul', [_vm._l((item.contentList), function(value) {
      return [_c('li', [_vm._v(_vm._s(value))])]
    })], 2), _vm._v(" "), _c('el-button', {
      staticClass: "right-button",
      on: {
        "click": function($event) {
          return _vm.bannerClick(item.code, item.name)
        }
      }
    }, [_vm._v("获取方案详情")])], 1)])])
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "更多产业",
      "name": "more"
    }
  })], 2)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "srm-advantage"
  }, [_c('div', {
    staticClass: "clearfix advantage-box"
  }, [_c('div', {
    staticClass: "clearfix tc"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.indexTitle[2].name || 'undefined'))]), _vm._v(" "), _c('p', [_vm._v("采用创新技术，立足采购当下，助力企业采购数字化转型")])]), _vm._v(" "), _c('div', {
    staticClass: "advantage-content"
  }, _vm._l((_vm.advantageList), function(item) {
    return _c('div', {
      staticClass: "advantage-item"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": item.title
      }
    }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('ul', [_vm._l((item.list), function(value) {
      return [_c('li', [_vm._v(_vm._s(value))])]
    })], 2)])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "srm-clientele"
  }, [_c('div', {
    staticClass: "clientele-box"
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.indexTitle[3].name || 'undefined'))]), _vm._v(" "), _c('p', [_vm._v("打造采购管理服务口碑企业")])]), _vm._v(" "), _c('div', {
    staticClass: "clientele-content"
  }, _vm._l((_vm.clienteleCon), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "clientele-item"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.shouy_logo),
        expression: "$global.globalPath + item.shouy_logo"
      }],
      attrs: {
        "alt": item.title
      }
    })])
  }), 0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "srm-client"
  }, [_c('div', {
    staticClass: "w1200"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.indexTitle[4].name || 'undefined'))]), _vm._v(" "), _c('SpeechSwiper', {
    attrs: {
      "mark": 1
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "srm-journalism"
  }, [_c('div', {
    staticClass: "journalism-box"
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.indexTitle[6].name || 'undefined'))]), _vm._v(" "), _c('h2', [_vm._v("了解采购领域动态，紧跟采购管理趋势")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix journalism-con"
  }, [_c('a', {
    staticClass: "fl journalism-con-left cp db",
    attrs: {
      "href": _vm.getCompanyLink(_vm.newsDescrible.id, _vm.newsDescrible.cat_id),
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "journalism-left-img"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.$global.globalPath + _vm.newsDescrible.img),
      expression: "$global.globalPath + newsDescrible.img"
    }],
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "alt": _vm.newsDescrible.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "journalism-left-span"
  }, [_c('h1', {
    staticClass: "journalism-title"
  }, [_vm._v(_vm._s(_vm.newsDescrible.title))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "new-title"
  }, [_vm._v(_vm._s(_vm.newsDescrible.origin))]), _vm._v(" "), _c('p', {
    staticClass: "new-detail"
  }, [_vm._v("查看详情 >")])])])]), _vm._v(" "), _c('el-timeline', {
    staticClass: "fl clearfix journalism-con-right cp db",
    attrs: {
      "reverse": _vm.reverse
    }
  }, _vm._l((_vm.newList), function(item, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "timestamp": item.year
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.getCompanyLink(item.id, item.cat_id),
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "item-date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "descible"
    }, [_vm._v(_vm._s(item.origin))])])])
  }), 1), _vm._v(" "), _vm._m(2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "rel clearfix srm-relation"
  }, [_c('div', {
    staticClass: "srm-relation-content"
  }, [_c('div', {
    staticClass: "left-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/form.svg"),
      "alt": _vm.indexTitle[5].name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [(!_vm.successRegister) ? _c('div', [_c('h1', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.indexTitle[5].name || 'undefined'))]), _vm._v(" "), _c('div', {
    staticClass: "srm-relation-form"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "model": _vm.ruleForm,
      "status-icon": "",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "name",
      "placeholder": "请输入姓名",
      "maxlength": 20,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", $$v)
      },
      expression: "ruleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 11,
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.ruleForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mobile", $$v)
      },
      expression: "ruleForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "validate-code",
    attrs: {
      "prop": "validate"
    }
  }, [_c('el-input', {
    staticClass: "form-input validate",
    attrs: {
      "maxlength": 4,
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.ruleForm.validate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "validate", $$v)
      },
      expression: "ruleForm.validate"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "validate-img",
    attrs: {
      "src": _vm.validateUrl,
      "alt": "请求失败,请检查网络"
    },
    on: {
      "mousedown": _vm.disableDrag
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "validate-span",
    on: {
      "click": _vm.changeCode
    }
  }, [_vm._v("看不清?换一张")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "form-button",
    attrs: {
      "disabled": _vm.canSubmit
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("立即提交\n                ")]), _vm._v(" "), _c('el-button', {
    staticClass: "form-button",
    on: {
      "click": _vm.goConsult
    }
  }, [_vm._v("咨询客服")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.successRegister) ? _c('div', {
    staticClass: "register-success"
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("甄云顾问将会联系您并为您提供专业的讲解与演示")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "index-video"
  }, [_c('el-dialog', {
    attrs: {
      "custom-class": "customClass",
      "visible": _vm.centerDialogVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      },
      "close": _vm.closeVideoDialog
    }
  }, [_c('div', {
    staticClass: "video-test"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVideoImg),
      expression: "showVideoImg"
    }],
    staticClass: "video-img tc cp",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.videoPlay.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "video-title dib"
  }, [_vm._v(_vm._s(_vm.videoText))])]), _vm._v(" "), _c('div', {
    staticClass: "homeDialog-video",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.videoClick.apply(null, arguments)
      }
    }
  }, [_c('video', {
    attrs: {
      "src": _vm.videoPlayData,
      "id": "homeVideo",
      "preload": "auto",
      "controls": "",
      "autoplay": "",
      "controlsList": "nodownload"
    },
    on: {
      "seeked": _vm.videoSeek,
      "pause": _vm.videoClick,
      "error": _vm.videoError,
      "ended": _vm.videoDown
    }
  })])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "srm-section1"
  }, [_c('div', {
    staticClass: "section1-item"
  }, [_c('span', [_vm._v("600+")]), _vm._v(" "), _c('span', [_vm._v("标杆企业")])]), _vm._v(" "), _c('div', {
    staticClass: "section1-item"
  }, [_c('span', [_vm._v("30+")]), _vm._v(" "), _c('span', [_vm._v("行业应用")])]), _vm._v(" "), _c('div', {
    staticClass: "section1-item"
  }, [_c('span', [_vm._v("20W+")]), _vm._v(" "), _c('span', [_vm._v("供应商")])]), _vm._v(" "), _c('div', {
    staticClass: "section1-item"
  }, [_c('span', [_vm._v("1.6万亿")]), _vm._v(" "), _c('span', [_vm._v("采购交易额")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "more"
  }, [_c('a', {
    attrs: {
      "href": "/clientele",
      "target": "_blank"
    }
  }, [_vm._v("查看更多客户案例 >")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/company",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "look-more"
  }, [_vm._v("查看更多 >")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/register/icon_check.svg"),
      "alt": "恭喜您，注册成功"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("恭喜您，注册成功！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56613988"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 396
// module chunks = 12